import { useState, useCallback, useEffect } from "react";
import { fetchPromosList } from "ppt/api";
import { usePPTActions } from "tap/store/ppt/usePPT";
import { usePPTToasts } from "./usePPTToasts";

/**
 * Hook to manage promo list data fetching and loading state.
 * Separates data fetching logic from UI components.
 */
export const usePromoListData = (hasPptPermission) => {
  const [loading, setLoading] = useState(true);
  const [hasLoadedOnce, setHasLoadedOnce] = useState(false);
  const { updatePromos } = usePPTActions();
  const { showErrorToast } = usePPTToasts();

  const loadPromos = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await fetchPromosList();
      updatePromos(data);
    } catch (err) {
      console.error("Error fetching promos list:", err);
      showErrorToast("Error fetching Promos. Please try again later.");
    } finally {
      setLoading(false);
      setHasLoadedOnce(true);
    }
  }, [updatePromos, showErrorToast]);

  useEffect(() => {
    if (hasPptPermission) {
      loadPromos();
    }
  }, [hasPptPermission, loadPromos]);

  return { loading, hasLoadedOnce, loadPromos };
};
